import React, { useState, useEffect } from 'react'
import { Message, Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import InputForm from '../../../components/forms/input/InputForm'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { cloneDeep } from 'lodash-es'
import { numberThousandSeparator } from '../../../utils/formatterUtil'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import pathname from '../../../constants/pathname'
import {
  deleteSettingFormActivity,
  saveSettingFormActivities,
} from '../../../redux/actions/subProjectFormSetting'
import notification from '../../../utils/notification'
import { CANCEL, DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ActivitieSettingFormWidget from './ActivitieSettingFormWidget'
import EditFormDescriptionWidget from '../dynamicForm/EditFormDescriptionWidget'
import { doneLoading, startLoading } from '../../../utils/loading'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import { TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function ActivitieSettingWidget(props) {
  // const { showCommandButton, isEdit, onChangeIsEdit, isSubProject } = props
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [activities, setActivities] = useState([])
  const [activityIndex, setActivityIndex] = useState(1)
  const [notiMsg, setNotiMsg] = useState()
  const [isRefash, setIsRefash] = useState(false)
  const [delActivityId, setDelActivityId] = useState()

  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    setActivities(props.schema.activities || [])
  }, [props.schema])

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveSettingFormActivities(formId, request)
      if (response?.forms?.activity) {
        setFormSchema(response.forms.activity)
        setNotiMsg({
          type: 'success',
          msg: SAVE_SUCCESS_MSG,
        })
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 2500,
        })
        onRefash()
      } else {
        setNotiMsg({
          type: 'error',
          msg: DEFAULT_ERR_MSG,
        })
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)
      setNotiMsg({
        type: 'error',
        msg: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)

    setTimeout(() => {
      setNotiMsg('')
    }, 2500)
  }

  const handleDelete = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await deleteSettingFormActivity(formId, id)
      if (response?.forms?.activity) {
        // setFormSchema(response.forms.activity)
        setActivities(response.forms.activity?.activities || [])
        setNotiMsg({
          type: 'success',
          msg: SAVE_SUCCESS_MSG,
        })
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 2500,
        })
        onRefash()
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    setDelActivityId('')

    doneLoading()
    setIsLoading(false)

    setTimeout(() => {
      setNotiMsg('')
    }, 2500)
  }

  const onSubmit = (data) => {
    // console.log('data', data)

    let request = {
      id: formSchema.id,
      detail: data.detail || null,
      note: data.note || null,
      // values: values,
      descValues: data.descSettingValues || [],
      descDelIds: data.descDelIds || [],
      additionalSupport: data.additionalSupport,
      additionalSupportDetail: data.additionalSupportDetail,
      //requestMaximum: data.requestMaximun,
      requestMaximunDetail: data.requestMaximunDetail,
    }
    // console.log('request : ', JSON.stringify(request))

    handleSave(request)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
      scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
    }, 50)
  }

  const handleAdd = () => {
    let atts = cloneDeep(activities || [])

    let obj = {
      id: 'NEW_' + (activityIndex + 1),
      enableEdit: true,
      activityName: '',
      activityDetail: '',
      outcomes: [],
      newOutcomes: [],
      activityTime: [],
      activityBudgetNote: null,
    }

    atts.push(obj)

    setActivities(atts)
    setActivityIndex(activityIndex + 1)
  }

  const handleDel = (id, index) => {
    if (id.startsWith('NEW_')) {
      let atts = cloneDeep(activities || [])

      atts.splice(index, 1)

      setActivities(atts)
    } else {
      setDelActivityId(id)
    }
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {!isRefash && (
        <>
          {formSchema.descriptionSetting && (
            <EditFormDescriptionWidget
              schema={formSchema.descriptionSetting}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          )}

          {formSchema.detail && (
            <div style={{ marginTop: -10, marginBottom: 20 }}>
              <CKEditorFrom
                schema={formSchema.detail}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </div>
          )}

          {activities?.map((e, index) => {
            return (
              <ActivitieSettingFormWidget
                schema={formSchema}
                activity={e}
                activityIndex={index}
                onDelete={handleDel}
              />
            )
          })}

          <SaveButton
            style={{ marginTop: 0, marginBottom: 20 }}
            icon="plus"
            children="เพิ่มกิจกรรม"
            onClick={handleAdd}
          />

          {formSchema.activitiNote && (
            <Panel header={'ส่วนเสริม'} bordered collapsible defaultExpanded>
              {/* <InputForm
                schema={formSchema.activitiNote.requestMaximun}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                isInputNumber={true}
              /> */}
              <CKEditorFrom
                schema={formSchema.activitiNote.requestMaximunDetail}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
              <InputForm
                schema={formSchema.activitiNote.additionalSupport}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                isInputNumber={true}
              />
              <CKEditorFrom
                schema={formSchema.activitiNote.additionalSupportDetail}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
              {/* <hr />
              <div style={{ width: '100%', textAlign: 'center', fontWeight: 'bolder' }}>
                <p>
                  {formSchema.activitiNote.limitBuugetText}{' '}
                  {numberThousandSeparator(
                    formSchema.activitiNote.requestMaximun.value +
                      formSchema.activitiNote.additionalSupport.value
                  )}{' '}
                  บาท
                </p>
              </div> */}
            </Panel>
          )}

          {formSchema.note && (
            <>
              <hr />
              <CKEditorFrom
                schema={formSchema.note}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </>
          )}
        </>
      )}

      <hr />
      {notiMsg && (
        <Message
          closable
          showIcon
          type={notiMsg.type}
          description={notiMsg.msg}
          onClose={() => setNotiMsg('')}
          style={{ marginBottom: 10 }}
        />
      )}
      <div className="right">
        <ViewButton
          style={{
            marginRight: 10,
            marginBottom: 10,
          }}
          onClick={() => {
            window.open(`${pathname.subProjectNew.proposal.activities}?preView`, '_blank')
          }}
          children={'แสดงตัวอย่าง'}
        />
        <SaveButton children={'บันทึก'} disabled={isLoading} onClick={handleSubmit(onSubmit)} />
        <CancelButton children={CANCEL} onClick={onRefash} />
      </div>

      <ConfirmWidget
        title={`ยืนยัน`}
        show={delActivityId}
        detail={`ยืนยันการลบกิจกรรม `}
        onCancle={() => setDelActivityId('')}
        onConfirm={() => handleDelete(delActivityId)}
      />

      {isLoading && <OverlayLoader />}
    </Panel>
  )
}
